// src/pages/workout/PainExerciseGuide/AreaPage.js

import { useNavigate, useSearchParams } from "react-router-dom";
import { useLoadingGate } from "../../../../../hooks/useLoadingGate";
import AuthCard from "../../../../../components/auth/AuthCard";
import BottomNav from "../../../../../components/common/BottomNav";

const AREA_ITEMS = {
    neck: {
        title: "목 근육",
        items: [
            { key: "neck_scalene", label: "목갈비근(사각근)" },
            { key: "neck_levator", label: "어깨올림근(견갑거근)" },
            { key: "neck_subscap", label: "어깨밑근(견갑하근)" },
            { key: "neck_cervical", label: "목널판근(경판상근)" },
            { key: "neck_trap", label: "등세모근(승모근)" },
            { key: "neck_suboccip", label: "뒤통수밑근(후두하근)" },
            { key: "neck_scm", label: "목빗근(흉쇄유돌근)" },
            { key: "neck_semispinalis", label: "목반가시근(경반극근)" },
            { key: "neck_splenius", label: "머리널판근(두판상근)" },
            { key: "neck_trap_lower", label: "아래등세모근(하승모근)" },
            { key: "neck_trap_upper", label: "위등세모근(상승모근)" },
            { key: "neck_longus", label: "긴목근육(경장근)" },
            { key: "neck_multifidus", label: "목뭇갈래근(경추다열근)" },
            { key: "neck_trap_middle", label: "중간등세모근(중부승모근)" },
        ],
    },
    shoulder: {
        title: "어깨 근육",
        items: [
            { key: "shoulder_supraspinatus", label: "가시위근(극상근)" },
            { key: "shoulder_infraspinatus", label: "가시아래근(극하근)" },
            { key: "shoulder_teres_major", label: "큰원근(대원근)" },
            { key: "shoulder_deltoid", label: "어깨세모근(삼각근)" },
            { key: "shoulder_teres_minor", label: "어깨작은원근(소원근)" },
            { key: "shoulder_rotator_cuff", label: "회전근개(어깨돌림근띠)" },
        ],
    },
    arm: {
        title: "팔 근육",
        items: [
            { key: "arm_brachialis", label: "위팔근(상완근)" },
            { key: "arm_triceps", label: "위팔세갈래근(상완삼두근)" },
            { key: "arm_brachioradialis", label: "위팔노근(상완요골근)" },
            { key: "arm_biceps", label: "위팔두갈래근(상완이두근)" },
            { key: "arm_flexor", label: "손목굽힘근(수지굴근)" },
            { key: "arm_pronator_teres", label: "원엎침근(원회내근)" },
            { key: "arm_palmaris_longus", label: "긴손바닥근(장장근)" },
            { key: "arm_supinator", label: "뒤침근(회외근)" },
            { key: "arm_coracobrachialis", label: "부리상완근(오훼상완근)" },
        ],
    },

    abdomen_lumbar: {
        title: "복부 / 허리 근육",
        items: [
            { key: "abdomen_rectus", label: "배곧은근(복직근)" },
            { key: "lumbar_quadratus", label: "허리네모근(요방형근)" },
            { key: "lumbar_psoas_major", label: "큰허리근(장요근)" },
            { key: "lumbar_erector", label: "척추세움근(척추기립근)" },
            { key: "abdomen_rectus_appendix", label: "복직근(맹장염)" },
            { key: "lumbar_multifidus", label: "요추다열근(천장관절기능부전)" },
            { key: "lumbar_quadratus_sij", label: "요방형근(천장관절기능부전)" },
            { key: "abdomen_external_oblique", label: "외복사근(배바깥빗근)" },
            { key: "abdomen_rectus_lower", label: "하부복직근(아래배곧은근)" },
            { key: "abdomen_rectus_upper", label: "상부복직근(위배곧은근)" },
            { key: "abdomen_internal_oblique", label: "내복사근(배속빗근)" },
            { key: "core_stabilizer", label: "코어안정화 근육(Core Stabilizer)" },
        ],
    },

    thigh: {
        title: "상퇴 근육",
        items: [
            { key: "thigh_vastus_medialis", label: "안쪽넓은근(내측광근)" },
            { key: "thigh_adductor_magnus", label: "큰모음근(대내전근)" },
            { key: "thigh_tfl", label: "넙다리근막긴장근(대퇴근막장근)" },
            { key: "thigh_rectus_femoris", label: "넙다리곧은근(대퇴직근)" },
            { key: "thigh_gracilis", label: "두덩정강근(박근)" },
            { key: "thigh_sartorius", label: "넙다리빗근(봉공근)" },
            { key: "thigh_hamstrings", label: "뒤넙다리근(슬굴곡근)" },
            { key: "thigh_popliteus", label: "오금근(슬와근)" },
            { key: "thigh_vastus_lateralis", label: "가쪽넓은근(외측광근)" },
            { key: "thigh_adductor_longus", label: "긴모음근(장내전근)" },
            { key: "thigh_vastus_intermedius", label: "중간넓은근(중간광근)" },
            { key: "thigh_pectineus", label: "두덩근(치골근)" },
            { key: "thigh_biceps_femoris", label: "넙다리두갈래근(대퇴이두근)" },
            { key: "thigh_medial_hamstrings", label: "내출슬굴곡근(안쪽무릎굽힘근)" },
            { key: "thigh_hip_flexors", label: "고관절 굴곡근(Hip Flexor Muscle)" },
            { key: "thigh_hip_adductor_complex", label: "고관절 내전근군(Hip Adductor complex)" },
            { key: "thigh_hip_internal_rotators", label: "고관절 내회근군(Hip internal rotator)" },
            { key: "thigh_hip_external_rotators", label: "고관절 외회근군(Hip external rotator)" },
            { key: "thigh_iliopsoas", label: "엉덩허리근(장요근)" },
        ],
    },


    lower_leg: {
        title: "하퇴 근육",
        items: [
            { key: "lower_leg_soleus", label: "넙치근(가자미근)" },
            { key: "lower_leg_peroneus", label: "종아리근(비골근)" },
            { key: "lower_leg_gastrocnemius", label: "장딴지근(비복근)" },
            { key: "lower_leg_fdl", label: "긴발가락굽힘근(장지굴근)" },
            { key: "lower_leg_edl", label: "긴발가락폄근(장지신근)" },
            { key: "lower_leg_tib_ant", label: "앞정강근(전경골근)" },
            { key: "lower_leg_plantaris", label: "장딴지빗근(족척근)" },
            { key: "lower_leg_tib_post", label: "뒤정강근(후경골근)" },
            { key: "lower_leg_gastro_lat", label: "외측비복근(바깥장딴지근)" },
            { key: "lower_leg_gastro_med", label: "내측비복근(안쪽장딴지근)" },
        ],
    },

};

export default function PainAreaPage() {
    const ready = useLoadingGate();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const regionKey = searchParams.get("item") || "neck"; // neck, shoulder, ...
    const fromTitle = searchParams.get("title") || "";
    const config = AREA_ITEMS[regionKey];

    const pageTitle = config?.title || fromTitle || "통증 부위 세부 선택";
    const items = config?.items || [];


    const handleSelectItem = (item) => {
        const qs = new URLSearchParams({
            cat: "pain",
            item: item.key,
            title: item.label,
        }).toString();

        navigate(`/workout/conditionguide/pain/detail?${qs}`);
    };

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto scrollbar-hide px-7 md:px-8 bg-white">
            {!ready ? (
                <div className="flex-1" />
            ) : (
                <AuthCard
                    className="flex-1 w-full mx-auto"
                    title={pageTitle}
                    onClose={() => navigate(-1)}
                >
                    <div className="flex flex-col flex-1 pt-3 md:pt-4 pb-24 md:pb-28">


                        {/* 카드 그리드 (2 x 2) */}
                        <div className="mt-4 grid grid-cols-2 gap-3">
                            {items.map((m) => (
                                <button
                                    key={m.key}
                                    type="button"
                                    onClick={() => handleSelectItem(m)}
                                    className="flex flex-col rounded-2xl overflow-hidden bg-white border border-gray-200 shadow-sm active:scale-[0.98] transition"
                                >
                                    <div className="w-full aspect-[3/4] bg-gray-100 flex items-center justify-center overflow-hidden">
                                        <img
                                            src={`/assets/muscle/${m.key}.png`}
                                            alt={m.label}
                                            className="w-full h-full object-cover"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                    <div className="py-2 px-2 text-center text-xs md:text-sm font-semibold">
                                        {m.label}
                                    </div>
                                </button>
                            ))}
                        </div>


                    </div>
                </AuthCard>
            )}

            <BottomNav className="h-16 md:h-[72px]" />
        </main>
    );
}
